module.exports = __webpack_public_path__ + "img/newicon6.af3f04e2.svg";